// Style guide colors for the scheduling surfaces (docs/STYLE_GUIDE.md).
// Each value reads a CSS variable from src/index.css, so the guide stays the
// one source of truth. Use these instead of raw hex values.

const tint = (cssVar: string, percent: number) =>
  `color-mix(in srgb, var(${cssVar}) ${percent}%, transparent)`;

export const schedulingTokens = {
  primary: 'var(--medley-green-primary)',
  primaryTint: tint('--medley-green-primary', 8),
  primaryTintHover: tint('--medley-green-primary', 14),
  success: 'var(--medley-green-success)',
  danger: 'var(--medley-red-danger)',
  dangerTint: tint('--medley-red-danger', 10),
  dangerBorder: tint('--medley-red-danger', 30),
  warningBg: 'var(--medley-bg-warning)',
  textPrimary: 'var(--medley-text-primary)',
  textSecondary: 'var(--medley-text-secondary)',
  textTertiary: 'var(--medley-text-tertiary)',
  bgMain: 'var(--medley-bg-main)',
  surface: 'var(--medley-bg-surface)',
  surfaceLight: 'var(--medley-surface-light)',
  borderLight: 'var(--medley-border-light)',
  border: 'var(--medley-border)',
  borderDark: 'var(--medley-border-dark)',
} as const;
